// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2foIy","head":"Table_head__3o_Dh","col":"Table_col__ejkE3"};